export const mediaMaxScreenPC = 3000;
export const mediaScreenTablet = 1199;
export const mediaScreenMobile = 833;
export const mediaMinScreenMobile = 325;
